<p-confirmDialog [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<div class="row">
	<div class="col-lg-12">
		<div class="ibox float-e-margins">
			<div class="ibox-content">
				<form name="ActionForm" class="form-horizontal" role="form" novalidate>
					<div class="form-group">
						<label class="col-sm-3 col-lg-2 control-label">School</label>
						<div class="col-sm-4 col-lg-3">
							<!-- <select  class="form-control" name="SchoolID" (ngModelChange)="onSchoolChange($event)" [(ngModel)]="report.SchoolID">
                               
                                <option *ngFor="let o of schoolList" [ngValue]="o.SchoolID">{{o.SchoolNumber}} - {{o.SchoolName}}</option>
                            </select> -->

							<caass-schoolselector [ShowAll]="false" [Disabled]="loading"> </caass-schoolselector>
						</div>
					</div>
					<div class="form-group">
						<label class="col-sm-3 col-lg-2 control-label">School Number</label>
						<div class="col-sm-4 col-lg-3">
							<input [disabled]="loading" type="text" class="form-control" name="SchoolNumber" [(ngModel)]="Contact.SchoolNumber" />
						</div>
					</div>
					<div class="form-group">
						<label class="col-sm-3 col-lg-2 control-label">Phone</label>
						<div class="col-sm-4 col-lg-3">
							<!-- <p class="form-control" >  {{Contact?.Phone}} </p>  -->
							<input [disabled]="loading" type="text" class="form-control" name="Phone" [(ngModel)]="Contact.Phone" />
						</div>
					</div>
					<div class="form-group">
						<label class="col-sm-3 col-lg-2 control-label">Street</label>
						<div class="col-sm-4 col-lg-3">
							<!-- <p class="form-control">{{Contact?.Street}} </p> -->
							<input [disabled]="loading" type="text" class="form-control" name="Street" [(ngModel)]="Contact.Street" />
						</div>
					</div>
					<div class="form-group">
						<label class="col-sm-3 col-lg-2 control-label">City</label>
						<div class="col-sm-4 col-lg-3">
							<input [disabled]="loading" type="text" class="form-control" name="City" [(ngModel)]="Contact.City" />

							<!-- <p class="form-control">{{Contact?.City}} </p> -->
						</div>
					</div>
					<div class="form-group">
						<label class="col-sm-3 col-lg-2 control-label">State</label>
						<div class="col-sm-4 col-lg-3">
							<input [disabled]="loading" type="text" class="form-control" name="State" [(ngModel)]="Contact.State" />
							<!-- <p class="form-control">{{Contact?.State}} </p> -->
						</div>
					</div>
					<div class="form-group">
						<label class="col-sm-3 col-lg-2 control-label">Zip</label>
						<div class="col-sm-4 col-lg-3">
							<input [disabled]="loading" type="text" class="form-control" name="Zip" [(ngModel)]="Contact.Zip" />
							<!-- <p class="form-control">{{Contact?.Zip}} </p> -->
						</div>
					</div>

					<div class="hr-line-dashed"></div>

					<div class="form-group">
						<label class="col-sm-3 col-lg-2 control-label"></label>
						<div class="col-md-4 col-lg-3">
							<!-- <div name="Saveing" class='alert alert-info'>Processing.Please wait...</div> -->
							<button
								[disabled]="report.SchoolID == 0 || loading == true"
								name="btnUpdate"
								class="btn btn-primary"
								type="button"
								(click)="SchoolUpdate()"
							>
								Update</button
							>&nbsp;
							<!-- <span *ngIf="record.saved" style="color:green"> Record Saved! </span> -->
							<!-- <button name="btnVwfacilities" *ngIf="!isProcessing" class="btn btn-primary" type="button" (click)="ViewFacilities()">View </button> -->
						</div>
					</div>
				</form>
			</div>
		</div>
	</div>
</div>
